module.exports = __webpack_public_path__ + "img/17.4c4e1ca8.jpg";